export default () => {
  $('.add-btn').on('click', () => {
    $('.custom-block').slideDown();
  })

  $('.add-to-list').on('click', () => {
    const techniqueName = $('.main-input--technique').val();
    // const workingHours = $('.main-input--hours').val();
    const serialNumber =  $('.main-input--number').val();
    const newTechniqueItem = `${techniqueName} ${serialNumber}`;
    const customHiddenInput = $('.custom-block__hidden')[0];
    if ($('.main-input--technique').val() !== '' && $('.main-input--hours').val() !== '' && $('.main-input--number').val() !== '') {
      customHiddenInput.value = `${serialNumber}`;
      $('.technique-pick').append(`<option data-number="${serialNumber}" value="${newTechniqueItem}">${newTechniqueItem}</option>`)
      global.customSelect.update('.technique-pick');
      $('.custom-block').slideUp();
      $('.custom-block__error').fadeOut(500);
      $('.custom-block__form input').val('');
      $('.select .select__list').mCustomScrollbar();

      $('.select').on('click', function clickSelect() {
        if ($('.select').hasClass('select--open')) {
          $('.select').removeClass('select--open');
          $(this).toggleClass('select--open');
        }
      });

    } else {
      $('.custom-block__error').fadeOut(500);
      $('.custom-block__error').fadeIn(500);
    }
  })

  function fileDelete() {
    $('.file__delete').on('click', function() {
      $(this).parent().remove();
    })
  }
  fileDelete();


  // $('#uploadfiles').on('change', function (e) {
  //   const files = e.target.files;
  //   const output = [];
  //   for (let i = 0, f; f = files[i]; i+= 1) {
  //     const filesName = escape(f.name);
  //     const fileName = f.name;
  //     output.push(`<div class="file__item"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/images/sprite.svg#file"></use></svg><a href="${fileName}" target="_blank">${fileName}</a> <span class="file__delete"><svg><use xlink:href="/images/sprite.svg#close"></use></svg></span> </div>`);
  //   }
  //   $('.file__list').append(output.join(''));
  //   fileDelete();
  // });

  // $.fn.fileUploader = function func1(filesToUpload, sectionIdentifier) {
  //   var fileIdCounter = 0;
  //   this.closest(".uploadfiles__inner").change( function (evt) {
  //     var output = [];

  //     for (let i = 0; i < evt.target.files.length; i++) {
  //       fileIdCounter++;
  //       var file = evt.target.files[i];
  //       var fileId = sectionIdentifier + fileIdCounter;
  //       filesToUpload.push({
  //           id: fileId,
  //           file
  //       });
  //       var fileIcon = `<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/images/sprite.svg#file"></use></svg>`
  //       var removeLink = `<span class="file__delete"><svg><use xlink:href="/images/sprite.svg#close"></use></svg></span>`;
  //       output.push('<div class="file__item">', fileIcon, '<a href="Nazvanie_file.pdf" target="_blank">', escape(file.name), '</a>', removeLink, '</div>');
  //     };

  //     $(this).find(".file__list").append(output.join(""));
  //     evt.target.value = null;
  //   });

  //   $(this).parents('.uploadfiles__inner').on("click", ".file__delete", function(e) {
  //     e.preventDefault();
  //     var fileId = $(this).parent().children("a").data("fileid");
  //     for (var i = 0; i < filesToUpload.length; ++i) {
  //       if (filesToUpload[i].id === fileId)
  //           filesToUpload.splice(i, 1);
  //     }
  //     $(this).parent().remove();
  //   });

  //   this.clear = function () {
  //     for (let i = 0; i < filesToUpload.length; ++i) {
  //       if (filesToUpload[i].id.indexOf(sectionIdentifier) >= 0)
  //            filesToUpload.splice(i, 1);
  //     }
  //     $(this).children(".file__list").empty();
  //   }

  //   return this;
  // };

  // (function() {
  //   const filesToUpload = [];
  //   const filesUploader = $("#uploadfiles").fileUploader(filesToUpload, "uploadfiles");
  //   console.log(filesToUpload);


  //   $(".submit-btn").click( function(e) {
  //     const formData = new FormData();
  //     console.log('111');
  //     for (let i = 0, len = filesToUpload.length; i < len; i++) {
  //         formData.append("files", filesToUpload[i].file);
  //         console.log('222');
  //     }
  //   });


    // $(".submit-btn").click( function(e) {
    //   e.preventDefault();
    //   const formData = new FormData();
    //   for (let i = 0, len = filesToUpload.length; i < len; i++) {
    //       formData.append("files", filesToUpload[i].file);
    //   }
    //   $.ajax({
    //       url: "http://requestb.in/1k0dxvs1",
    //       data: formData,
    //       processData: false,
    //       contentType: false,
    //       type: "POST",
    //       success: function (data) {
    //           alert("DONE");
    //           files1Uploader.clear();
    //       },
    //       error: function (data) {
    //           alert("ERROR - " + data.responseText);
    //       }
    //   });
    // });
  // })()



  $('.settings svg').on('click', function() {
    $('.management-block').fadeOut(100);
    $('.management-block.management-block--edit').fadeIn(500);
    const employeeName = $(this).parents('tr').find('.name').text();
    const employeePosition = $(this).parents('tr').find('.position').text();
    const employeeEmail = $(this).parents('tr').find('.email').text();
    const employeePhone = $(this).parents('tr').find('.phone').text();
    const employeeId = $(this).parents('tr').find('.id').text();
    const employeeOkpo = $(this).parents('tr').find('.okpo').text();

    $('.management-block--edit .hidden__customer_id').val(employeeId);
    $('.management-block--edit .form-input--management-name input').val(employeeName);
    $('.management-block--edit .form-input--management-position input').val(employeePosition);
    $('.management-block--edit .form-input--management-email input').val(employeeEmail);
    $('.management-block--edit .form-input--management-phone input').val(employeePhone);
    $('.management-block--edit .form-input--management-okpo input').val(employeeOkpo);
  })

  let clicked = false;
  $('.rate__inner .rate .rate__star').click(function (event) {
    const index = $(this).index() + 1;
    $(this).parent().attr('data-rate', index);
  });
  $('.rate__inner .rate .rate__star').click((event) => {
    clicked = true;
  });

  $('.table__logist-connectivity .table-row.has-child > .table-cell').on('click', function() {
    const linkItem = $(this).parent();
    const popupInfo = $(this).parent().find('.table-cell__popup');
    if (linkItem.hasClass('active') || popupInfo.hasClass('open')) {
      linkItem.removeClass('active');
      popupInfo.removeClass('open');
    } else {
      $('.table__logist-connectivity .table-row.has-child').removeClass('active');
      $('.table-cell__popup').removeClass('open');
      linkItem.addClass('active');
      popupInfo.addClass('open');
    }
  })

  $(document).on('click', (e) => {
    if (!$(e.target).closest('.table__logist-connectivity .table-row.has-child > .table-cell, .table-cell__popup').length) {
      $('.table-cell__popup').removeClass('open');
      $('.table__logist-connectivity .table-row.has-child').removeClass('active');
    }
    e.stopPropagation();
  });

  $('.table__logist-clients .table-row.has-child > .table-cell').on('click', function() {
    const linkItem = $(this).parent();
    const popupInfo = $(this).parent().find('.table-cell__select-dispetcher');
    if (linkItem.hasClass('active') ||popupInfo.hasClass('open')) {
      linkItem.removeClass('active');
      popupInfo.removeClass('open');
    } else {
      $('.table__logist-clients .table-row.has-child').removeClass('active');
      $('.table-cell__select-dispetcher').removeClass('open');
      linkItem.addClass('active');
      popupInfo.addClass('open');
    }
  })

  $(document).on('click', (e) => {
    if (!$(e.target).closest('.table__logist-clients .table-row.has-child > .table-cell, .table-cell__select-dispetcher').length) {
      $('.table-cell__select-dispetcher').removeClass('open');
      $('.table__logist-clients .table-row.has-child').removeClass('active');
    }
    e.stopPropagation();
  });

  $('.table-cell__show-list').on('click', function() {
    $(this).parent().next().parents('.table-row.has-child').addClass('active');
    $(this).parent().next().toggleClass('open');
    $('.table__body--scroll').mCustomScrollbar();
  })

  const changeValueItem = $('.table-cell__select-dispetcher .table__body .table-row');
  changeValueItem.on('click', function() {
    const thisName = $(this).find('.table-cell--name').text();
    const thisRegion = $(this).find('.table-cell--region').text();
    const thisEmail = $(this).find('.table-cell--email').text();
    const thisPhone =  $(this).find('.table-cell--phone').text();
    const mainName = $(this).parents('.table-cell__select-dispetcher').find('.table__header').find('.table-cell__name span');
    const mainRegion = $(this).parents('.table-cell__select-dispetcher').find('.table__header').find('.table-cell__region span');
    const mainEmail = $(this).parents('.table-cell__select-dispetcher').find('.table__header').find('.table-cell__email span');
    const mainPhone =  $(this).parents('.table-cell__select-dispetcher').find('.table__header').find('.table-cell__phone span');

    changeValueItem.removeClass('cheked').removeClass('active');
    $(this).addClass('cheked');
    mainName.text(thisName);
    mainRegion.text(thisRegion);
    mainEmail.text(thisEmail);
    mainPhone.text(thisPhone);
  })

  $('.create-application__sidebar .checkbox-block label').on('click', () => {
    if($('#contact-person')[0].checked){
      $('.create-application__sidebar-form').css('display', 'none');
    } else {
      $('.create-application__sidebar-form').css('display', 'block');
    }
  })
}



// WEBPACK FOOTER //
// app/scripts/components/area.js